<locations-selector
  [config]="config"
  [regionId]="selectedCountry"
  [selected]="selected"
  (selectedChange)="update($event)"
></locations-selector>
